import axios from "axios";

export default async function createStaff(access_token, email, fullName) {
  const resp = await axios.post(
    `${process.env.REACT_APP_ORGANISER_API}/pos/staff/create`,
    {
      email,
      fullName,
    },
    {
      headers: {
        token: access_token,
      },
    }
  );

  if (!resp.data) {
    throw new Error("Some error occured");
  }
  if (resp.data.error) {
    throw new Error(resp.data.error);
  }

  return resp.data;
}
